var SPiD = this.SPiD || {};

/**
 * Collection of functions to aid in functional programming.
 */

(function () {
    'use strict';

    SPiD.throttle = function throttle(fn, ms) {
        var timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(null, arguments);
            }, ms);
        };
    };

}());
